<template>
  <div>
    <generic-container
      :title="$t('reports')"
      icon="line chart"
      :searchable="true"
      v-on:filter="filter"
      :header_buttons="header_buttons"
      ref="container"
    >
      <!-- <div class="ui grid">
        <div class="four wide column">
          <div class="ui vertical fluid menu secondary pointing" ref="tabs">
            <a
              class="item"
              :data-tab="item.uuid"
              v-for="(item, index) in reports_by_module"
              :key="index"
            >
              {{ $t(item.module) }}
              <div class="ui label">{{ item.reports.length }}</div>
            </a>
          </div>
        </div>
        <div class="twelve wide stretched column">
          <div
            class="ui bottom attached tab segment"
            :data-tab="item.uuid"
            v-for="(item, index) in reports_by_module"
            :key="index"
          >
            <div class="ui selection list">
              <div
                class="item"
                v-for="(rpt, idx) in item.reports"
                :key="idx"
                @click.stop="show_report(rpt)"
              >
                <img class="mini ui image" src="/images/icons/endpoint.png" />
                <div class="content" style="width: 90%">
                  <div
                    class="ui mini basic right floated icon button"
                    @click.stop="monit_endpoint(rpt)"
                    :data-tooltip="$t('monit')"
                  >
                    <i class="eye icon"></i>
                  </div>
                  <a class="header">{{ rpt.module }} </a>
                  <div class="description">
                    <pre>{{ rpt }}</pre>
                  </div>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="ui two cards">
        <div
          class="card"
          v-for="(item, index) in reports_by_module"
          v-bind:key="index"
          @click="show_reports(item)"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/report.png"
            />
            <div class="header">
              {{ $t(item.module) }}
              <small>| {{ reports_number(item.reports) }}</small>
            </div>
            <div class="meta">
              <span>{{ reports_number(item.reports) }}</span>
            </div>
            <div class="ui selection list" v-if="item.show_reports">
              <div
                class="item"
                v-for="(rpt, idx) in item.reports"
                :key="idx"
                @click="show_report(rpt)"
              >
                <i class="text file icon"></i>
                <div class="content">
                  <a class="header">{{ rpt.name }}</a>
                  <div class="description">{{ rpt.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre>{{ reports_by_module }}</pre> -->
    </generic-container>
    <template v-for="(mdl, index) in report_modals">
      <component
        :is="mdl"
        :key="index"
        :report="selected_report"
        @destroy="destroy"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api } from "@/utils";
import { cloneDeep } from "lodash";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";
// import ReportModal from "./ReportModal";

// @ is an alias to /src
export default {
  name: "ReportIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      reports_by_module: [],
      all_reports_by_module: [],
      show_report_composer: false,
      report_modals: [],
      selected_report: {},
      header_buttons: [
        {
          icon: "orange edit",
          click: this.compose_report,
          tooltip: this.$t("report composer"),
        },
      ],
    };
  },
  computed: {},
  methods: {
    // add() {
    //   this.popup_modals.push(ProviderModal);
    // },
    succedded(p) {
      console.log(p);
      this.destroy();
    },
    destroy() {
      this.report_modals = [];
    },
    filter(filter) {
      // console.log(filter);
      if (filter == "")
        this.reports_by_module = cloneDeep(this.all_reports_by_module);
      else
        this.reports_by_module = this.all_reports_by_module.filter(
          (n) =>
            n.module.toUpperCase().includes(filter.toUpperCase()) ||
            n.reports.find((r) =>
              r.name.toUpperCase().includes(filter.toUpperCase()),
            ),
        );
    },
    reports_number(reports) {
      let lngth = reports.length;
      if (lngth == 1) return `${lngth} ${this.$i18n.t("report")}`;
      else if (lngth > 1) return `${lngth} ${this.$i18n.t("reports")}`;
      else return "¿?";
    },
    show_reports(item) {
      this.reports_by_module.map((m) => {
        m.show_reports = true;
      });
      item.show_reports = true;
    },
    show_report(rpt) {
      // this.selected_report = rpt;
      // this.report_modals.push(ReportModal);
      this.$router.push({ name: "ReportViewer", query: { i: rpt.uuid } });
    },
    compose_report() {
      this.$router.push({ name: "ReportComposer" });
    },
  },
  mounted() {
    let vm = this;
    vm.$refs.container.set_loading(true);
    local_api(vm, "post", "/report/do-get-available")
      .then((reports_by_module) => {
        vm.$refs.container.set_loading(false);
        let _r = reports_by_module.map((m) => {
          m.uuid = v4();
          m.show_reports = true;
          return m;
        });
        // let _providers = providers.sort(function(a, b) {
        //   if (a.name > b.name) return 1;
        //   if (b.name > a.name) return -1;
        //   return 0;
        // });
        this.reports_by_module = _r;
        this.all_reports_by_module = cloneDeep(_r);
        setTimeout(() => {
          window.jQuery(vm.$refs.tabs).find(".item").tab();
        }, 500);
      })
      .catch((err) => {
        vm.$refs.container.set_loading(false);
        vm.$alertify.error(JSON.stringify(err, null, 2));
      });
  },
  watch: {},
};
</script>
